import React, { useEffect, useState, Fragment } from 'react';
import { AlertTriangleIcon, ArrowRightIcon } from 'lucide-react';
const CART_URL = 'https://fbwqku-s9.myshopify.com/cart/52013268271396:1';
interface UrgencyCTABlockProps {
  headline?: string;
  subtext?: string;
  buttonText?: string;
  /** Offset in minutes from now for the countdown */
  offsetMinutes?: number;
}
export function UrgencyCTABlock({
  headline = 'Accedé ahora antes de que se agoten los cupos',
  subtext = 'Todo esto incluido en un solo pago único',
  buttonText = 'Quiero acceder ahora',
  offsetMinutes = 97
}: UrgencyCTABlockProps) {
  const [timeLeft, setTimeLeft] = useState(() => {
    const total = offsetMinutes * 60;
    return {
      hours: Math.floor(total / 3600),
      minutes: Math.floor(total % 3600 / 60),
      seconds: total % 60
    };
  });
  useEffect(() => {
    const target = Date.now() + offsetMinutes * 60 * 1000;
    const timer = setInterval(() => {
      const distance = target - Date.now();
      if (distance <= 0) {
        clearInterval(timer);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      setTimeLeft({
        hours: Math.floor(distance / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [offsetMinutes]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="bg-gradient-to-b from-white to-pink-50/30 py-12 md:py-16 px-4" data-id="element-450">
      <div className="container mx-auto max-w-2xl" data-id="element-451">
        <div className="backdrop-blur-sm bg-white rounded-3xl border-2 border-[#FF4DB8]/20 shadow-lg shadow-pink-500/10 p-8 md:p-10 text-center" data-id="element-452">
          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 bg-rose-50 border border-rose-200 px-4 py-2 rounded-full mb-6" data-id="element-453">
            <AlertTriangleIcon className="w-4 h-4 text-rose-500 animate-pulse" aria-hidden="true" data-id="element-454" />
            <span className="text-sm font-bold text-rose-600 uppercase tracking-wide" data-id="element-455">
              ¡Solo quedan 3 cupos disponibles!
            </span>
          </div>

          {/* Cupos dots */}
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-456">
            {[...Array(10)].map((_, i) => <div key={i} className={`w-5 h-5 rounded-full border-2 transition-all duration-300 ${i < 7 ? 'bg-rose-400 border-rose-500' : 'bg-white border-[#FF4DB8]'}`} aria-hidden="true" data-id="element-457" />)}
          </div>
          <p className="text-xs text-[#6B6B6B] mb-6" data-id="element-458">7 de 10 cupos tomados</p>

          {/* Countdown */}
          <div className="flex items-center justify-center gap-3 mb-8" role="timer" aria-live="polite" data-id="element-459">
            {[{
            value: pad(timeLeft.hours),
            label: 'hs'
          }, {
            value: pad(timeLeft.minutes),
            label: 'min'
          }, {
            value: pad(timeLeft.seconds),
            label: 'seg'
          }].map((unit, i) => <Fragment key={i} data-id="element-460">
                {i > 0 && <span className="text-2xl font-bold text-[#FF4DB8] mb-4" data-id="element-461">
                    :
                  </span>}
                <div className="flex flex-col items-center bg-gradient-to-br from-[#FFD6EC]/40 to-[#FFB3E6]/40 rounded-2xl px-4 py-3 min-w-[64px] border border-pink-100" data-id="element-462">
                  <span className="text-2xl md:text-3xl font-extrabold text-[#FF4DB8] leading-none" data-id="element-463">
                    {unit.value}
                  </span>
                  <span className="text-xs text-[#6B6B6B] font-medium mt-1" data-id="element-464">
                    {unit.label}
                  </span>
                </div>
              </Fragment>)}
          </div>

          {/* Headline */}
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 leading-tight" data-id="element-465">
            {headline}
          </h3>
          <p className="text-[#6B6B6B] mb-8" data-id="element-466">{subtext}</p>

          {/* CTA Button */}
          <a href={CART_URL} className="inline-flex items-center gap-3 w-full justify-center px-8 py-5 bg-gradient-to-r from-[#FF4DB8] to-[#FF6EC7] hover:from-[#FF6EC7] hover:to-[#FF4DB8] text-white font-bold text-lg rounded-2xl shadow-lg shadow-pink-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-pink-500/40 hover:scale-105" data-id="element-467">
            {buttonText}
            <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-468" />
          </a>

          <p className="text-sm text-gray-500 mt-5" data-id="element-469">
            Acceso inmediato • Garantía 72hs • Pago seguro
          </p>
        </div>
      </div>
    </section>;
}